import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

export type VNFieldHelpIconConfig = {
  active: boolean;
  helperTooltip?: string;
  onClick?: () => void;
  ariaLabel?: string;
};

type VNFieldHelpContextValue = {
  /** Icon props for in-trigger placement (e.g. VNDropdown). Rendered by the child, not passed as JSX. */
  iconConfig: VNFieldHelpIconConfig | null;
};

const VNFieldHelpContext = createContext<VNFieldHelpContextValue>({ iconConfig: null });

export const VNFieldHelpProvider = ({
  iconConfig,
  children,
}: {
  iconConfig: VNFieldHelpIconConfig | null;
  children: ReactNode;
}) => {
  const value = useMemo(() => ({ iconConfig }), [iconConfig]);
  return <VNFieldHelpContext.Provider value={value}>{children}</VNFieldHelpContext.Provider>;
};

export const useVNFieldHelpContext = () => useContext(VNFieldHelpContext);

export default VNFieldHelpContext;
